export const UPDATE_TOKEN = "token/UPDATE_TOKEN";
export const CLEAR_TOKEN = "token/CLEAR_TOKEN";
export const SET_REMEMBER_ME = "token/SET_REMEMBER_ME";
